import deliveryOptionsService from './deliveryOptionsService'

export default deliveryOptionsService



// WEBPACK FOOTER //
// ../src/services/deliveryOptionsService/index.js